import React, { useState, useEffect } from "react";
import axios from "axios";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [uiStatus, setUiStatus] = useState({ type: "", text: "" }); // Combined state for clean alert handling
  const [isSubmitting, setIsSubmitting] = useState(false); // Submit button debounce guard

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setUiStatus({ type: "", text: "" });

    try {
      const response = await axios.post(
        "http://localhost:5000/api/contact",
        formData
      );

      // Checking for backup success text string if response backend payload varies
      const successMsg =
        response.data?.message ||
        "Your request has been submitted successfully!";

      setUiStatus({ type: "success", text: successMsg });
      setFormData({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Error submitting contact request. Please try again later.";
      setUiStatus({ type: "danger", text: errorMsg });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-7">
          <div className="card border shadow-sm p-4 sm-p-5">
            <h2 className="h3 fw-bold mb-1">Want Call Back - Fill Form</h2>
            <p className="text-muted small mb-4">
              Leave your details and our team will get in touch with you
              shortly.
            </p>

            {uiStatus.text && (
              <div
                className={`alert alert-${uiStatus.type} d-flex align-items-center mb-4`}
                role="alert"
              >
                <div>{uiStatus.text}</div>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label
                  htmlFor="name"
                  className="form-label fw-semibold text-secondary small"
                >
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label
                    htmlFor="email"
                    className="form-label fw-semibold text-secondary small"
                  >
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="name@example.com"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label
                    htmlFor="phone"
                    className="form-label fw-semibold text-secondary small"
                  >
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="Your phone number"
                  />
                </div>
              </div>

              <div className="mb-4">
                <label
                  htmlFor="message"
                  className="form-label fw-semibold text-secondary small"
                >
                  Message
                </label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="How can we help you?"
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-lg w-100 d-flex justify-content-center align-items-center gap-2"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : (
                  "Submit Request"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
